<div class="appo-appointment-request-confirm-date">
  <form #appoAppointmentRequestConfirmDateForm="ngForm"
        id="{{formId}}"
        name="{{formId}}">
    <div class="container-fluid px-0">
      <div *ngIf="showNotificationWarning" class="mb-2">
        <si-generic-alert [showAlert]="showNotificationWarning"
                          text="SI_ACTIVATE_NOTIFICATIONS"
        ></si-generic-alert>
      </div>
      <div *ngIf="showConfirmAccountWarning" class="mb-2">
        <si-generic-alert [showAlert]="showConfirmAccountWarning"
                          styleClass="error"
                          text="SI_CONFIRM_ACCOUNT_TO_CONFIRM_APPOINTMENT"
        ></si-generic-alert>
      </div>
      <div *ngIf="showCollectiveWarning" class="mb-2">
        <si-generic-alert [showAlert]="showCollectiveWarning"
                          styleClass="success"
                          text="SI_INSURANCE_WILL_BE_ADDED_AUTOMATICALLY"
        ></si-generic-alert>
      </div>
      <div class="row">
        <div class="col-12 appo-appointment-request-confirm-date_text mb-1">
          <div>{{'SI_APPOINTMENT_DETAIL' | translate}}</div>
        </div>
        <div class="col-12 col-lg-8 mb-3">
          <si-appo-appointment-highlight [startDate]="model.startDate"
                                         [centerName]="model.center?.name"
                                         [professionalName]="model.professional?.name"
                                         [serviceName]="model.service?.name"
                                         [assistanceTypeCode]="model.teleconsultation"
                                         [reasonName]="model.appointmentReason[0]?.name"
                                         [collectiveName]="model.collective?.name"
          ></si-appo-appointment-highlight>
        </div>
        <div *ngIf="maskedEmail || maskedPhone" class="col-12 pasi-line-lightgrey"></div>
        <div class="col-12">
          <div *ngIf="maskedEmail" class="d-flex flex-wrap">
            <si-check id="appointmentCheckEmail"
                      name="appointmentCheckEmail"
                      text="SI_SEND_EMAIL"
                      [(model)]="model.emailNotification"
            ></si-check>
            <span class="appo-appointment-request-confirm-date_masked">({{maskedEmail}})</span>
          </div>
          <div *ngIf="maskedPhone" class="d-flex flex-wrap mt-3">
            <si-check id="appointmentCheckSMS"
                      name="appointmentCheckSMS"
                      text="SI_SEND_SMS"
                      [(model)]="model.smsNotification"
            ></si-check>
            <span class="appo-appointment-request-confirm-date_masked">({{maskedPhone}})</span>
          </div>
        </div>
      </div>
    </div>
  </form>
  <ng-container *ngIf="displaySlotErrorDialog">
    <si-generic-dialog [(displayDialog)]="displaySlotErrorDialog"
                       [closable]="false"
                       dialogTitle="SI_BOOKING_ERROR"
                       dialogImg="assets/images/error_found.svg"
                       [dialogText]="slotErrorText"
                       button1Text="SI_REQUEST_AGAIN"
                       button1Class="si-button_main"
                       (updateButton1Change)="onClickRequestAgainButton()"
    ></si-generic-dialog>
  </ng-container>
</div>
